import { render, staticRenderFns } from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=template&id=2936d7ff&scoped=true&"
import script from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsentDoubleOptinConfirmationPage.vue?vue&type=style&index=0&id=2936d7ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936d7ff",
  null
  
)

export default component.exports